<div *ngIf="(loaderService.loading$ | async)" class="loader-overlay">
    <!-- Loader spinner or animation -->
    <div class="loader"></div>
  </div>
